import { render, staticRenderFns } from "./chair_ai.vue?vue&type=template&id=0e2e375c&scoped=true&"
import script from "./chair_ai.vue?vue&type=script&lang=js&"
export * from "./chair_ai.vue?vue&type=script&lang=js&"
import style0 from "./chair_ai.vue?vue&type=style&index=0&id=0e2e375c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e2e375c",
  null
  
)

export default component.exports